import * as yup from "yup";

const LoginSchema = yup.object().shape({
    email: yup
        .string()
        .email("Please enter a valid email!")
        .required("Please Enter Email"),
    password: yup
        .string()
        .min(8, "Password must be longer than 8 characters")
        .required("Password is required"),
});

export default LoginSchema;